<div class="content-height d-lg-block d-none">
    <div class="h-100">    
        <div class="container wrapper w-100 h-100 d-flex flex-column justify-content-center align-items-center">
            <div class="" [ngClass]="!showBankLogos ? '': ''">
                <lottie-player src="https://lottie.host/54a863ac-9ad8-40a5-9502-eb235504e9ff/SSqBU9x69w.json"
                background="transparent" speed="1" style="width: 200px;" class="img img-fluid" direction="1"
                mode="normal" once autoplay></lottie-player>
            </div>
            
            <div *ngIf="showBankLogos" class="show-logos d-flex justify-content-center align-items-center flex-column text-center">
                <h4 class="mb-3">Your loan application has been <br> successfully sent to</h4>
    
                <div class="bank-logo-background px-3 py-1 mb-3">
                    <div class="row row-cols-4 text-center mt-3">
                        <div class="" *ngFor="let single of vendorList">
                            <img class="bankVendors mb-4" [src]="single?.vendor?.company?.logo" alt="">
                        </div>
                    </div>
                </div>
                
                <p class="fw-bold fs-5">Now, what’s next?</p>

                <div class="d-flex justify-content-between align-items-center mb-3">
                    <div class="me-2">
                        <a [routerLink]="puid?('/application-status/'+puid):('/application-status')"
                        class="btn btn-outline-primary px-8 py-2">Check Status</a>
                    </div>

                    <div class="">
                        <a [routerLink]="puid?('/upload-documents/'+puid):('/upload-documents')"
                        class="btn btn-primary px-7 py-2">Upload Documents</a>
                    </div>
                </div>
    
                <div class="bank-logo-background text-start p-2">
                    <div class="d-flex justify-content-between align-items-center">
                        <img class="img img-fluid me-2"
                            src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1715943058805Frame%2026609%201.png"
                            alt="phone_icon">
                        <h6 class="mt-3">
                            Your selected lender will be contacting you within 24-48 hours. Please make sure to pick the
                            call
                        </h6>
                    </div>
    
                </div>
    
            </div>
        </div>
    </div>
</div>

<div class="d-lg-none d-block full_screen">
    <div class="container wrapper w-100 h-100 d-flex flex-column justify-content-center align-items-center">
        <div class="" [ngClass]="!showBankLogos ? '': ''">
            <lottie-player src="https://lottie.host/54a863ac-9ad8-40a5-9502-eb235504e9ff/SSqBU9x69w.json"
            background="transparent" speed="1" style="width: 200px;" class="img img-fluid" direction="1"
            mode="normal" once autoplay></lottie-player>
        </div>
        
        <div *ngIf="showBankLogos" class="show-logos d-flex justify-content-center align-items-center flex-column text-center">
            <h1 class="mb-3">Your loan application has been successfully sent</h1>

            <div class="bank-logo-background p-2 mb-3">
                <h5 class="mb-4">You have applied to</h5>

                <div class="row row-cols-3">
                    <div class="" *ngFor="let single of vendorList">
                        <img class="bankVendors mb-4" [src]="single?.vendor?.company?.logo" alt="">
                    </div>
                </div>
            </div>

            <div class="mb-3">
                <a [routerLink]="puid?('/upload-documents/'+puid):('/upload-documents')"
                    class="btn btn-primary px-9 py-2 mb-2 w-100">Upload Documents</a>
                <a [routerLink]="puid?('/application-status/'+puid):('/application-status')"
                    class="btn btn-outline-primary px-9 py-2 w-100">Check Status</a>
            </div>

            <div class="bank-logo-background text-start p-2">
                <div class="d-flex justify-content-between align-items-center">
                    <img class="img img-fluid me-2"
                        src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1715943058805Frame%2026609%201.png"
                        alt="phone_icon">
                    <h6 class="mt-3">
                        Your selected lender will be contacting you within 24-48 hours. Please make sure to pick the
                        call
                    </h6>
                </div>

            </div>

        </div>
    </div>
</div>

<ng-template #content let-modal>
    <div class="modal-body">
        <div class="px-5">
            <div class="text-center text-primary-dark mb-6 py-4">
                <h4 class="mb-2">Your request has been send successfully. Our team will get back to you in 2-3 working
                    days</h4>
                <p class="text-muted">Thanks for co-operating with us </p>
            </div>
            <div class="d-flex justify-content-center align-items-center mt-n6">
                <img src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1677050781144woman%20in%20online%20meeting%20with%20graphic%20tablet.png"
                    alt="Thank you" class="img img-fluid">
            </div>
        </div>
    </div>
    <div class="modal-footer px-4">
        <a class="btn btn-primary w-100 text-light" (click)="modal.close('Close click'); clearDetails()">Thank you!</a>
    </div>
</ng-template>